import { PageContextConfig } from "../configurations";

// const dummyHelpContent = {
//     url: "https://support.yodlee.com/yodlee/analytics",
//     authUrl: "https://support.envestnet.com/sso/jwt",
//     details: {
//         analytics: {
//             url: "https://support.envestnet.com/yodlee/analytics",
//             authReq: true
//         },
//     },
// }

type IHelpContentDetails = {
    authReq: boolean,
    helpUrl: string,
    authUrl?: string,
}

const DEFAULT_HELP_CONTENT_KEY = "url", DEFAULT_AUTH_URL_KEY = "authUrl";
export const getHelpContentLinkDetails = (helpContentDataMap: Record<string, any>, path: string): IHelpContentDetails => {
    // const helpContentDataMap: any = dummyHelpContent;
    const pageContextName = PageContextConfig.PAGE_CONTEXT?.[path];
    const contextDetails = helpContentDataMap?.details?.[pageContextName];
    if (contextDetails?.authReq) {
        return { authReq: true, authUrl: helpContentDataMap?.[DEFAULT_AUTH_URL_KEY], helpUrl: contextDetails?.url };
    } else {
        const defaultUrl = helpContentDataMap?.[DEFAULT_HELP_CONTENT_KEY];
        return { authReq: false, helpUrl: contextDetails?.url || defaultUrl };
    }
}

export const loadHelpContentWithAuth = (helpContentUrl: string, authUrl: string, jwToken: string) => {
    postForm(authUrl, { token: jwToken, callback: helpContentUrl })
}

const postForm = (path: string, params: any) => {
    const form = document.createElement('form');
    form.method = "POST";
    form.action = path;
    form.target = "_blank";
    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = params[key];
            form.appendChild(hiddenField);
        }
    }
    document.body.appendChild(form);
    form.submit();
}